import { z } from 'zod';

export const sourcePreparationTargetOutboundTypeValues = ['SHIPMENT', 'COVER_SHIPMENT'] as const;
export type SourcePreparationTargetOutboundType =
  (typeof sourcePreparationTargetOutboundTypeValues)[number];
export const SourcePreparationTargetOutboundTypeSchema: z.ZodType<SourcePreparationTargetOutboundType> =
  z.enum(sourcePreparationTargetOutboundTypeValues);

export const sourcePreparationRequestStatusValues = [
  'PENDING',
  'CLAIMED',
  'MATERIALIZED',
  'INVALIDATED',
  'CANCELED',
] as const;
export type SourcePreparationRequestStatus =
  (typeof sourcePreparationRequestStatusValues)[number];
export const SourcePreparationRequestStatusSchema: z.ZodType<SourcePreparationRequestStatus> =
  z.enum(sourcePreparationRequestStatusValues);

export const sourcePreparationTerminalReasonCodeValues = [
  'web_canceled',
  'desktop_edit_discarded',
  'desktop_released',
  'desktop_discarded',
  'candidate_line_set_changed',
  'line_already_claimed',
  'selection_resolved_differently',
  'load_session_no_longer_applicable',
  'reported_boundary_overlap',
  'context_resolution_changed',
  'holding_units_evidence_changed',
  'duplicate_attachment',
  'attachment_unavailable',
  'attachment_changed',
  'attachment_reserved_by_other',
  'attachment_scope_changed',
  'own_purchase_conflict',
  'own_purchase_fingerprint_changed',
  'context_changed',
  'sync_pending',
] as const;
export type SourcePreparationTerminalReasonCode =
  (typeof sourcePreparationTerminalReasonCodeValues)[number];
export const SourcePreparationTerminalReasonCodeSchema: z.ZodType<SourcePreparationTerminalReasonCode> =
  z.enum(sourcePreparationTerminalReasonCodeValues);
